<template>
  <div
    :class="{
      'fact-finder-categories': true,
      'fact-finder-categories--is-slider': isSliderActive,
    }"
  >
    <div class="fact-finder-categories__label">
      {{ $dict.get('product-List.Facets.Categories.Label') }}
    </div>
    <div
      v-if="isMounted"
      class="md:fi-hidden"
    >
      <splide
        :options="{
          drag: 'free',
          snap: true,
          arrows: false,
          autoWidth: true,
        }"
      >
        <splide-slide
          v-for="category in categories"
          :key="category.id"
          ref="categorySlider"
          :class="{
            'fact-finder-categories__slide': true,
            'fact-finder-categories__slide--fite': isFiteApp,
          }"
        >
          <category-item-fi
            :category="category"
            :filter-url-params="filterUrlParams"
            @toggle="$emit('toggle', category, $event)"
          />
        </splide-slide>
      </splide>
    </div>
    <div
      :class="{
        'fact-finder-categories__flex': true,
        'fact-finder-categories__flex--ssr': !isMounted,
        'fact-finder-categories__flex--fite': isFiteApp,
      }"
    >
      <category-item-fi
        v-for="category in categories"
        :key="category.id"
        :category="category"
        :filter-url-params="filterUrlParams"
        @toggle="$emit('toggle', category, $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-ignore - vue-splide package has type resolution issues
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { onMounted, ref, watch } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';
import { useFischer } from '@/composables/fischerPlugin';

import CategoryItemFi from './CategoryItemFi.vue';

export interface Category {
  id: string;
  name: string;
  enabled: boolean;
  Slug: string;
  imageUrl?: string;
  selected: boolean;
}

defineEmits<{
  toggle: [value: Category, enabled: boolean];
}>();

withDefaults(
  defineProps<{
    categories?: Array<Category>;
    filterUrlParams?: string;
  }>(),
  {
    categories: () => [],
    filterUrlParams: '',
  },
);

const { isLG, windowDimensions } = useBreakpoints();
const fischer = useFischer();
const isFiteApp = fischer.app.isFite();

const isSliderActive = ref(false);
const isMounted = ref(false);
const categorySlider = ref<InstanceType<typeof SplideSlide> | null>(null);

onMounted(() => {
  isMounted.value = true;
});

const setSlider = (): void => {
  if (!categorySlider.value || IS_SSR) {
    return;
  }

  let slidesWidth = 0;
  categorySlider.value.$el
    .querySelectorAll('.fact-finder-categories__item')
    .forEach((s: HTMLElement) => {
      slidesWidth += s.offsetWidth;
    });

  isSliderActive.value = !isLG.value && slidesWidth > categorySlider.value.$el.offsetWidth;
};

watch(windowDimensions, () => setSlider, {
  deep: true,
  immediate: true,
});
</script>

<style scoped src="./fact-finder-categories" />

<style src="./fact-finder-categories-unscoped" />
